<div class="empty-state">
  <div class="mat-headline-4">Manage your phone(s) with OnSIP</div>
  <div class="mat-body-2">
    OnSIP makes managing phones easy by connecting your device at no extra cost.
  </div>
  <button mat-flat-button color="primary" (click)="addNewPhone.emit()">Add a phone</button>
</div>
